module.exports = __webpack_public_path__ + "509fc51d7523e9c68bc055c5e6f0e9b4.svg";